import { useState } from "react";

import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { getTranslateByKey } from "@/main/services/utils";

import FiltersSearchIntegration from "./filtersSearchIntegration/filtersSearchIntegration";
import GridSearchIntegration from "./gridSearchIntegration/gridIntegrationScreen";
import { IntegrationInterfaceCompanyResponse } from "@/main/models/response";
import { IntegrationInterfaceCompanyRequest } from "@/main/models/request";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";

function SearchIntegrationScreen() {
	const [dataGrid, setDataGrid] = useState<IntegrationInterfaceCompanyResponse[]>([]);
	const [formFilters, setFormFilters] = useState<IntegrationInterfaceCompanyRequest | null>(null);

	function onResetSearch() {
		setDataGrid([]);
		setFormFilters(null);
	}

	async function getDataIntegrationInterfaceCompany(
		filters: IntegrationInterfaceCompanyRequest | Partial<IntegrationInterfaceCompanyRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: IntegrationInterfaceCompanyRequest = {
			...(isResetSearch ? {} : formFilters),
			...(filters as IntegrationInterfaceCompanyRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		onResetSearch();
		setFormFilters(request);
	}

	const titlePage = `${getTranslateByKey("module.integration")} > ${getTranslateByKey("screen.searchIntegration")}`;
	return (
		<ContainerScreen title={titlePage}>
			<FiltersSearchIntegration
				getDataIntegrationInterfaceCompany={getDataIntegrationInterfaceCompany}
				onResetSearch={onResetSearch}
			/>
			<GridSearchIntegration formFilters={formFilters} dataGrid={dataGrid} setDataGrid={setDataGrid} />
		</ContainerScreen>
	);
}

export default withQueryparams(SearchIntegrationScreen);
